module.exports = __webpack_public_path__ + "static/commercial-general-liability-insurance-29000fb6699a8a2f0e69b929cc0be734.svg";